import React from 'react';
import { ButtonBase, Typography } from '@mui/material';

const TimelineTimeLabel = ({ time, onEdit, sx }) => !time && !onEdit ? null : (
  <Typography
    component={onEdit ? ButtonBase : 'span'}
    onClick={onEdit ? (event) => { event.stopPropagation(); onEdit(); } : undefined}
    aria-label={onEdit ? (time ? `Edit date and time: ${time}` : 'Set date and time') : undefined}
    title={onEdit ? 'Edit date and time' : undefined}
    sx={sx}
  >
    {time || 'Set time'}
  </Typography>
);

export default TimelineTimeLabel;
